import Grid from "@mui/material/Grid";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import styles from "./styles";
import { useState } from "react";
import { AccordionIconPropsInterface } from "@mv-types";
import useStyles from "@hooks/useStyle";

interface AccordianPropsInterface {
	trigger?: JSX.Element;
	customClasses?: { [key: string]: string };
	children: JSX.Element;
	clickedTrigger?: (val: Boolean) => void;
	iconProps?: AccordionIconPropsInterface;
	defaultExpanded?: boolean;
}

const Accordian = (props: AccordianPropsInterface) => {
	const { trigger, customClasses, children, clickedTrigger, iconProps } = props;
	const iconPlacement = iconProps?.iconPlacement ?? "left";
	const [isExpanded, setIsExpanded] = useState(props.defaultExpanded ?? false);
	const { classes, cx } = useStyles(styles) as any;

	const openIcon = iconProps?.customIconOpen ?? <ArrowRightIcon fontSize="small" />;
	const closeIcon = iconProps?.customIconClose ?? <ArrowDropDownIcon fontSize="small" />;
	return (
		<Grid container className={customClasses ? classes[customClasses.root] : ""}>
			<Grid
				onClick={() => {
					clickedTrigger?.(!isExpanded);
					setIsExpanded(!isExpanded);
				}}
				item
				className={cx(classes.verticleAlign, classes.cursorPointer, classes.triggerContainer)}
			>
				<>
					{iconPlacement === "left" && <>{isExpanded ? <>{closeIcon}</> : <>{openIcon}</>}</>}
					<div className={classes[iconProps?.customTriggerClass ?? ""]}>{trigger}</div>
					{iconPlacement === "right" && (
						<div className={classes[iconProps?.customIconsClass ?? ""]}>
							{isExpanded ? <>{closeIcon}</> : <>{openIcon}</>}
						</div>
					)}
				</>
			</Grid>
			{isExpanded && children}
		</Grid>
	);
};

export default Accordian;
